if (!customElements.get('discount-form')) {
  customElements.define(
    'discount-form',
    class DiscountForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form')

        this.input = this.form.querySelector('[data-discount-input]')
        this.cart = document.querySelector('cart-drawer');

        if(!this.input || !this.cart) throw new Error('Input and CartDrawer is required')

        this.form.addEventListener('submit', this.submitHandler.bind(this))
      }

      async submitHandler(event) {
        event.preventDefault();

        if(!this.input.value) return

        const response = await (await fetch('/cart/update.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({
            discount: [...await this.getDiscounts(), this.input.value].join(','),
            sections: this.cart.getSectionsToRender().map((section) => section.id)
          })
        })).json();


        const codeResponse = response.discount_codes.find(({code, applicable}) => code.toLowerCase() === this.input.value.toLowerCase())

        if(codeResponse)
          this.showMessage(codeResponse.applicable, response)

        this.cart.renderContents(response);
      }

      async getDiscounts(){
        try{
          return (await (await fetch('/cart.json')).json()).discount_codes.map(({code}) => code)
        }catch(error){
          console.error("Error getting cart:", error)
        }
      }

      showMessage(success, cart){
        this.messageWrapper = this.messageWrapper || this.querySelector('.discount-message');

        if(!this.messageWrapper) return;

        let [successPattern, failedPattern] = this.querySelector('template').content.children;
        let messagePattern = (success ? successPattern : failedPattern).outerHTML

        messagePattern = messagePattern.replace('[discount_code]', this.input.value);
        messagePattern = messagePattern.replace('[save-amount]', Shopify.formatMoney(cart.total_discount));

        this.messageWrapper.innerHTML = messagePattern;
      }
    }
  );
}


if (!customElements.get('float-message')) {
  customElements.define(
    'float-message',
    class FloatMessage extends HTMLElement {
      constructor() {
        super();

        this.querySelector('[data-close]')?.addEventListener('click', event => {
          this.remove()
        })
      }
    }
  );
}


if (!customElements.get('discount-code')) {
  customElements.define(
    'discount-code',
    class DiscountCode extends HTMLElement {
      constructor() {
        super();

        this.code = this.dataset.value

        this.querySelector('[data-close]')?.addEventListener('click', event => {
          this._remove()
        })
      }

      async _remove() {
        this.cart = document.querySelector('cart-drawer');
        if(!this.cart) return;

        const response = await (await fetch('/cart/update.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({
            // case-insensitive: the chip shows the code's canonical title, but the cart
            // stores whatever casing the customer typed (Shopify matches codes case-insensitively)
            discount: (await this.getDiscounts()).filter(code => code.toLowerCase() !== this.code.toLowerCase()).join(','),
            sections: this.cart.getSectionsToRender().map((section) => section.id)
          })
        })).json();

        this.cart.renderContents(response);
      }

      async getDiscounts(){
        try{
          return (await (await fetch('/cart.json')).json()).discount_codes.map(({code}) => code)
        }catch(error){
          console.error("Error getting cart:", error)
        }
      }
    }
  );
}